import { RegisterFunction } from "./RegisterFunction";
import { RegisterAdapter } from "./RegisterAdapter";
import { RegisterBasic } from "./RegisterBasic";
import { RegisterCot } from "./RegisterCot";
import { RegisterPreview } from "./RegisterPreview";
import { RegisterBlueprint } from "./RegisterBlueprint";
export class CorekitRegistry {
    static configure(container, params) {
        RegisterBasic.configure(container, params);
        RegisterFunction.configure(container);
        RegisterAdapter.configure(container);
        RegisterCot.configure(container);
        RegisterPreview.configure(container);
        RegisterBlueprint.configure(container);
    }
}
